// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_BxV","cls2":"Header-cls2_EMq Header-cls1_BxV"};